module.exports = __webpack_public_path__ + "img/add-icon.96135035.svg";